module.exports = __webpack_public_path__ + "static/media/player.0ae90195.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/coinRunner/player.png
// module id = 192
// module chunks = 0